import { useLayoutEffect, useState } from 'react';
import type { Row } from '@tanstack/react-table';
import clsx from 'clsx';

import { TABLE_CONSTANTS } from '../../shared/constants';

import { TableRow } from './TableRow';

interface TableBodyProps<TData = any> {
  rows: Row<TData>[];
  className?: string;
}

export function TableBody<TData = any>({ rows, className }: TableBodyProps<TData>) {
  const [headerHeight, setHeaderHeight] = useState<number>(TABLE_CONSTANTS.MIN_HEADER_HEIGHT);

  useLayoutEffect(() => {
    const header = document.getElementById('table-header');
    if (header) {
      setHeaderHeight(header.clientHeight === 0 ? TABLE_CONSTANTS.MIN_HEADER_HEIGHT : header.clientHeight);
    }
  }, []);

  const anyIsExpanded = rows.some((row) => row.getIsExpanded());

  return (
    <tbody className={clsx('bg-white', className)}>
      {rows.map((row, index) => (
        <TableRow
          anyIsExpanded={anyIsExpanded}
          headerHeight={headerHeight}
          isFirstRow={index === 0}
          isLastRow={index === rows.length - 1}
          key={row.id}
          row={row}
        />
      ))}
    </tbody>
  );
}
